import { Stack, SxProps, Theme } from '@mui/material';
import { TableV3 } from 'common/table';
import { CandidateProfileTableHeader } from 'modules/candidate-profile/components/CandidateProfileTableHeader';
import {
  layoutContainerPaddingX,
  layoutContainerPaddingY
} from 'services/navigation/components/PrivateRoute';
import { useCandidateProfileTalentPoolTableLogic } from 'modules/candidate-profile/tables/hooks/useCandidateProfileTalentPoolTableLogic';
import { CandidateProfileListProps } from 'modules/candidate-profile/types/CandidateProfileListProps';

const TALENT_POOL_TABLE_ID = 'candidate-profile-talent-pool-table';

const mainContainerStack: SxProps<Theme> = {
  px: layoutContainerPaddingX,
  py: layoutContainerPaddingY
};

export const CandidateProfileTalentPoolTable: React.FC<
  CandidateProfileListProps
> = (candidateProfileListProps) => {
  const {
    data,
    columns,
    loading,
    total,
    sort,
    currentPage,
    pageSize,
    onFiltersChanged,
    onSort,
    onChangePage,
    onChangePageSize
  } = useCandidateProfileTalentPoolTableLogic({ candidateProfileListProps });

  return (
    <Stack sx={mainContainerStack}>
      <CandidateProfileTableHeader
        candidateProfileListProps={candidateProfileListProps}
        conversationPanelOptions={null}
      />
      <TableV3
        tableId={TALENT_POOL_TABLE_ID}
        columns={columns}
        data={data}
        loading={loading}
        defaultSort={sort}
        onSort={onSort}
        onFiltersChanged={onFiltersChanged}
        paginationOptions={{
          pageSize,
          totalRows: total,
          currentPage,
          onChangePage,
          onChangePageSize
        }}
      />
    </Stack>
  );
};
